import _taggedTemplateLiteral from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    background-color: var(--card-bg-color);\n    color: var(--card-fg-color);\n\n    &:is(button) {\n      &:disabled {\n        ", "\n      }\n\n      &:not(:disabled) {\n        @media (hover: hover) {\n          &:hover {\n            ", "\n          }\n\n          &:active {\n            ", "\n          }\n        }\n\n        &:focus {\n          ", "\n        }\n\n        [aria-selected='true'] > & {\n          ", "\n        }\n      }\n    }\n\n    &:is(a) {\n      &[data-disabled] {\n        ", "\n      }\n\n      &:not([data-disabled]) {\n        @media (hover: hover) {\n          outline: none;\n\n          &:hover {\n            ", "\n          }\n\n          &:active {\n            ", "\n          }\n        }\n\n        &:focus {\n          ", "\n        }\n\n        [aria-selected='true'] > & {\n          ", "\n        }\n      }\n    }\n\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    --card-bg-color: ", ";\n    --card-fg-color: ", ";\n    --card-focus-ring-color: ", ";\n    --card-border-color: ", ";\n    --card-muted-fg-color: ", ";\n    --card-accent-fg-color: ", ";\n    --card-link-fg-color: ", ";\n    --card-code-bg-color: ", ";\n    --card-code-fg-color: ", ";\n\n    /* @todo: deprecate */\n    --card-link-color: ", ";\n    --card-hairline-soft-color: ", ";\n    --card-hairline-hard-color: ", ";\n\n    /* @todo: rename to \"--base-\"? */\n    --card-shadow-outline-color: ", ";\n    --card-shadow-umbra-color: ", ";\n    --card-shadow-penumbra-color: ", ";\n    --card-shadow-ambient-color: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &:is(button) {\n      -webkit-font-smoothing: inherit;\n      appearance: none;\n      outline: none;\n      font: inherit;\n      text-align: inherit;\n      border: 0;\n      width: stretch;\n    }\n\n    &:is(a) {\n      text-decoration: none;\n    }\n\n    &:is(pre) {\n      font: inherit;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
export function card(props) {
  return [cardBaseStyles, cardColorStyles(props)];
}
export function cardBaseStyles() {
  return css(_templateObject());
}

function vars(base, color) {
  // Custom properties that may be used by other atoms
  return css(_templateObject2(), color.bg, color.fg, base.focusRing, color.border, color.muted.fg, color.accent.fg, color.link.fg, color.code.bg, color.code.fg, color.link.fg, color.border, color.border, base.shadow.outline, base.shadow.umbra, base.shadow.penumbra, base.shadow.ambient);
}

export function cardColorStyles(props) {
  var _a, _b;

  var theme = props.theme;
  var _theme$sanity$color = theme.sanity.color,
      base = _theme$sanity$color.base,
      card = _theme$sanity$color.card;
  return css(_templateObject3(), vars(base, card.enabled), vars(base, card.disabled), vars(base, card.hovered), vars(base, card.pressed), vars(base, card.selected), vars(base, card.selected), vars(base, card.disabled), vars(base, card.hovered), vars(base, card.pressed), vars(base, card.selected), vars(base, card.selected), (_b = (_a = theme.sanity.styles) === null || _a === void 0 ? void 0 : _a.card) === null || _b === void 0 ? void 0 : _b.root);
}